// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"572":"509ee800","760":"f059d3b9","953":"ebec1422"}[chunkId] + ".chunk.css";
};